import React from 'react';
import { Typography, helperMargin } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';

export const Title: React.FC = () => {
  const { t } = useTranslation('conversion');
  return (
    <Typography.Title
      level={2}
      size={{ all: 'XXL', phonablet: 'XL' }}
      css={helperMargin({ bottom: 16, right: { phonablet: 40 } })}
    >
      {t('Conversion')}
    </Typography.Title>
  );
};
